import useDidMount from 'app/hook/common/useDidMount';
import useEnlog from 'app/hook/common/useEnlog';

export default function useTrackingEnlog(data) {
	const { enloggingJsonData } = useEnlog();

	useDidMount(() => {
		// 데이터토크
		const chkDataTalkAuto = typeof data?.dataTalkViewAuto === 'undefined' || data?.dataTalkViewAuto === true;
		const dataTalkView = data?.dataTalkView || {};

		// 엔로그
		enloggingJsonData({
			...(chkDataTalkAuto && { dataTalkView }),
			...data,
		});
	});
}
